export const syncMessagesAppBadge = async (count) => {
    const value = Number(count || 0);

    try {
        if (!("setAppBadge" in navigator) && !("clearAppBadge" in navigator)) {
            return;
        }

        if (value > 0 && "setAppBadge" in navigator) {
            await navigator.setAppBadge(value);
            return;
        }

        if ("clearAppBadge" in navigator) {
            await navigator.clearAppBadge();
        }
    } catch (e) {
        console.warn("syncMessagesAppBadge error:", e);
    }
};